const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/profile/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/profile/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ProfilePendingState } from '@/features/profile/components/ProfilePendingState';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/profile')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: ProfilePendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});